'use strict';

angular.module('dekky.forms.themes.far')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/far/fields/range.html',
		'<rzslider rz-slider-model="model.min" rz-slider-high="model.max" rz-slider-options="field.range"></rzslider>'
	);
});